// ======================================================================
// FILE:
// src/modules/wms/dashboard/components/TeamPerformanceTable.jsx
//
// MODULE:
// Work Management System (WMS)
//
// PURPOSE:
// Dynamic Team Performance table
// ======================================================================

import React from "react";


// ======================================================================
// COMPONENT
// ======================================================================

export default function TeamPerformanceTable({
  data = [],
}) {

  // --------------------------------------------------------------------
  // Ensure we always work with an array.
  // --------------------------------------------------------------------

  const rows = Array.isArray(data)
    ? data
    : [];


  // --------------------------------------------------------------------
  // Empty state
  // --------------------------------------------------------------------

  if (!rows.length) {

    return (

      <div className="card shadow-sm h-100">

        <div className="card-header bg-white">

          <h5 className="mb-0">
            Team Performance
          </h5>

        </div>

        <div className="card-body">

          <div className="text-center text-muted py-5">

            No team performance data available.

          </div>

        </div>

      </div>

    );

  }


  // ====================================================================
  // RENDER
  // ====================================================================

  return (

    <div className="card shadow-sm h-100">


      {/* ================================================================
          HEADER
          ================================================================ */}

      <div className="card-header bg-white">

        <h5 className="mb-0">
          Team Performance
        </h5>

      </div>


      {/* ================================================================
          TABLE
          ================================================================ */}

      <div className="card-body p-0">

        <div className="table-responsive">

          <table className="table table-hover align-middle mb-0">

            <thead className="table-light">

              <tr>

                <th>
                  Team
                </th>

                <th className="text-end">
                  Assigned
                </th>

                <th className="text-end">
                  In Progress
                </th>

                <th className="text-end">
                  Completed
                </th>

                <th className="text-end">
                  Pending
                </th>

                <th className="text-end">
                  Overdue
                </th>

                <th className="text-end">
                  SLA %
                </th>

                <th className="text-end">
                  Avg Time
                </th>

                <th className="text-end">
                  Efficiency
                </th>

              </tr>

            </thead>


            <tbody>

              {rows.map(
                (row, index) => {

                  const efficiency =
                    Number(
                      row?.efficiency ?? 0
                    );


                  const efficiencyClass =
                    efficiency >= 80
                      ? "text-success"
                      : efficiency >= 60
                        ? "text-warning"
                        : "text-danger";


                  const sla =
                    row?.sla;


                  return (

                    <tr
                      key={
                        row?.team_id
                        ?? index
                      }
                    >


                      {/* ==================================================
                          TEAM
                          ================================================== */}

                      <td>

                        <strong>

                          {
                            row?.team
                            || "-"
                          }

                        </strong>

                      </td>


                      {/* ==================================================
                          ASSIGNED
                          ================================================== */}

                      <td className="text-end">

                        {
                          row?.assigned
                          ?? 0
                        }

                      </td>


                      {/* ==================================================
                          IN PROGRESS
                          ================================================== */}

                      <td className="text-end">

                        {
                          row?.progress
                          ?? 0
                        }

                      </td>


                      {/* ==================================================
                          COMPLETED
                          ================================================== */}

                      <td className="text-end">

                        {
                          row?.completed
                          ?? 0
                        }

                      </td>


                      {/* ==================================================
                          PENDING
                          ================================================== */}

                      <td className="text-end">

                        {
                          row?.pending
                          ?? 0
                        }

                      </td>


                      {/* ==================================================
                          OVERDUE
                          ================================================== */}

                      <td className="text-end">

                        <span
                          className={
                            Number(
                              row?.overdue ?? 0
                            ) > 0
                              ? "text-danger fw-semibold"
                              : ""
                          }
                        >

                          {
                            row?.overdue
                            ?? 0
                          }

                        </span>

                      </td>


                      {/* ==================================================
                          SLA
                          ================================================== */}

                      <td className="text-end">

                        {
                          sla === null
                          || sla === undefined
                            ? "-"
                            : `${sla}%`
                        }

                      </td>


                      {/* ==================================================
                          AVG TIME
                          ================================================== */}

                      <td className="text-end">

                        {
                          row?.avgTime
                          || "-"
                        }

                      </td>


                      {/* ==================================================
                          EFFICIENCY
                          ================================================== */}

                      <td
                        className={
                          `text-end fw-semibold ${efficiencyClass}`
                        }
                      >

                        {efficiency}%

                      </td>


                    </tr>

                  );

                }
              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>

  );

}